
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Pagination from '../pagination/Pagination'
import { Form, Link } from 'react-router-dom'
import moment from 'moment'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { Container } from '@mui/system'
import { FaSearch } from 'react-icons/fa';
import { MDBBtn, MDBCollapse, MDBContainer, MDBFile, MDBValidation, MDBValidationItem } from 'mdb-react-ui-kit'
import Swal from 'sweetalert2';
import './index.css'



const ContestRule = () => {

  const [member, setMember] = useState([])
  const [showPerPage] = useState(20)
  const [pagination, setPagination] = useState(
    {
      start: 0,
      end: showPerPage
    }
  )

  const onChangePagination = (start, end) => {
    setPagination({ start: start, end: end })
  }

  const userId = sessionStorage.getItem("userId"); // Ensure this is stored at login
  const userType = sessionStorage.getItem("usertype");



  const [filteredMembers, setFilteredMembers] = useState([]);

const memberData = async () => {


  const res = await axios.get(`https://lionsdirectoryapi.emedha.in/report/api/contestRules`, {
    
  });

  setMember(res.data);
  setFilteredMembers(res.data);
  console.log(res.data);
};



  useEffect(() => {
    memberData()
 
  }, [])

  const [number, setSNumber] = useState('')
  const [contestRule, setContestRule] = useState('')
  const [units, setUnits] = useState('')
  const [points, setPoints] = useState('')

  const [search, setSearch] = useState()


  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseBulk=()=>setIsOpen1(false)


const submitData = (e) => {
  e.preventDefault();

  const formData = new FormData();
  formData.append('SNo', number);
  formData.append('contest_rule', contestRule);
  formData.append('units', units);
  formData.append('points', points);

  axios.post('https://lionsdirectoryapi.emedha.in/report/api/contestCreate', formData)
    .then((response) => {
      if (response.status === 200) {
        alert(response.data);  // shows 'Contest rule created successfully!'
        setShow(false);
        setTimeout(() => memberData(), 100);
      } else {
        alert('Unexpected response: ' + response.status);
      }
    })
    .catch((err) => {
      // err.response may be undefined, so safe check
      const errorMessage = err.response?.data || err.message || 'Unknown error';
      alert('Error: ' + errorMessage);
    });
};




const deleteData = (id) => {


  if (window.confirm('Are you sure to delete this data...')) {
    axios.delete(`https://lionsdirectoryapi.emedha.in/report/api/deleteContest/${id}`)
      .then(() => {
        alert('Data deleted successfully!...');
        setTimeout(() => memberData(), 100);
      })
      .catch(err => alert("Error deleting data"));
  }
};

const searchHandler = (e) => {

  const searchValue = e.target.value;

  setSearch(searchValue);

  axios.post('https://lionsdirectoryapi.emedha.in/report/api/contestSearch', {
    search: searchValue,

  }).then((resp) => {
    setFilteredMembers(resp.data);
  }).catch((err) => {
    console.error("Search error:", err);
  });
};

  


  const [isOpen1, setIsOpen1] = React.useState(false);
  const toggleOpen1 = () => setIsOpen1(!isOpen1);
  const [bfile, setBfile] = useState(null);


    const handleFileChange = (e) => {
      console.log('Selected File:', e.target.files[0]);
      setBfile(e.target.files[0]);
    };
    



const bulkuploadhandle = async (e) => {

  e.preventDefault();

  if (!bfile) {
    Swal.fire({
      icon: 'error',
      title: 'File Required',
      text: 'Please select a file to upload.',
    });
    return;
  }

  try {
    const formData = new FormData();
    formData.append('file', bfile);


    const response = await axios.post('https://lionsdirectoryapi.emedha.in/report/api/api/contestBulkUpload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response.status === 200) {
      toggleOpen1();
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Data submitted successfully!',
        customClass: {
          confirmButton: 'custom-swal-button',
        },
      }).then(() => {
        alert('submitted successfully');
            memberData()
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
      });
    }
  } catch (error) {
    console.error('Error:', error);
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Something went wrong!',
    });
  }
};

  

  return (

    <>
      <Container><h5 className='text-center text-danger'></h5></Container>
   <Button variant="primary" onClick={handleShow}>
        Add<PersonAddAltIcon></PersonAddAltIcon>
      </Button>
 <Button rounded className='mx-3' color='secondary'  onClick={toggleOpen1}>
        Bulk upload
      </Button>
    
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <br /><br /><br /><br /><br />
          <Modal.Title>Add</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={submitData}>
            <input type='number' className='form-control' placeholder='S.No' required onChange={(e) => setSNumber(e.target.value)} />
            <br />
            <input type='text' className='form-control' placeholder='Contest Rule' required onChange={(e) => setContestRule(e.target.value)} />
            <br />

            <input type='text' className='form-control' placeholder='Units'  onChange={(e) => setUnits(e.target.value)} />
            <br />

            <input type='number' className='form-control' placeholder='Points' onChange={(e) => setPoints(e.target.value)} />
            <br />
         
            <button type='submit' className='btn btn-danger form-control'>Submit</button>
            <br />
            <br />
            <button type='reset' className='btn btn-secondary form-control'>Reset</button>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <FaSearch className='searchIcon'></FaSearch><input type='search' className='ms-4 search-input-field' placeholder='Search..' onChange={searchHandler} />

  
  <Modal show={isOpen1} onHide={handleCloseBulk} size='md'>
      <Modal.Header closeButton>
        <br /><br /><br /><br /><br />
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={bulkuploadhandle}>
          <label htmlFor='fileFrom'>Choose excel file to upload bulk data</label>
          <input type="file" id='fileFrom' onChange={handleFileChange} />

          <div className='col-12'>
            <Button type='submit' style={{ marginBottom: 30 }}>Upload</Button>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseBulk}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
       
      
     
      <div style={{ marginTop: '1rem' }} className='table-container'>
        <table className="styled-table table  table-striped table-responsive table-bordered" >
          <thead>
            <tr>
              <th>S.No</th>
              <th>Contest Rule</th>
              <th>Units</th>
              <th>Points</th>
             
           <th>Update</th>
            <th>Delete</th>
            </tr>
          </thead>
          <tbody className='table-bordered'>
            {
              filteredMembers.slice(pagination.start, pagination.end).map((data, index) => {

             

                return (
                  <tr>
                    <td>{data.SNo}</td>
                    <td>{data.contest_rule}</td>
                    <td>{data.units}</td>
                    <td>{data.points}</td>
                
              <td className=''>
                      <Link to={`/updatec/${data.id}`} className='btn btn-info text-white'>update</Link>
                    </td>
           <td className=''>
                      <Link to='#' className='btn btn-danger' onClick={() => deleteData(data.membershipNo)}>delete</Link>
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
        <Pagination page={showPerPage} onChangePagination={onChangePagination} total={member.length} />
      </div>


    </>
  )
}

export default ContestRule